export default function getLocalTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}
